import { useEffect } from 'react';
import { useDeviceDetect, useFetchInboundMessagesDetails } from 'hooks';

export default (messages, onSelectConversationCb, selectedConversationId, period) => {
  const { isDesktop } = useDeviceDetect();
  const { meta: selectedConversationMeta, isLoading: isMetaLoading } = useFetchInboundMessagesDetails(selectedConversationId);

  useEffect(() => {
    const isActiveConversationSelected = selectedConversationMeta?.attributes.isActive;
    if (messages.length && isDesktop && !isMetaLoading && (period === 'active' ? !isActiveConversationSelected : isActiveConversationSelected)) {
      const initConversationId = messages[0]?.attributes.conversationId;
      onSelectConversationCb(initConversationId)();
    }
  }, [messages, selectedConversationId]);
};
